<template>
	<div class="tooltip-wrap">
		<span class="tooltip-opener">i</span>
		<div class="tooltip">
			<div class="tooltip-holder">
				<span class="tooltip-title">Why do I see a convenience Fee?</span>
				<p>
					We charge a small fee for the conveniences in offering you great
					access and control of your tab. With updates on the way there will be
					new services and tools making this all worth the additional spend...
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Tooltip'
}
</script>

<style lang="scss">
.tooltip-wrap {
	display: inline-block;
	vertical-align: top;
	position: relative;
}

.tooltip-opener {
	display: block;
	width: 16px;
	line-height: 14px;
	color: #2c2a35;
	text-align: center;
	border: 1px solid #2c2a35;
	border-radius: 50%;
	cursor: default;
}

.tooltip {
	position: absolute;
	left: -12px;
	bottom: 100%;
	padding: 0 0 13px;
	font-size: 14px;
	display: none;
}

.tooltip-wrap:hover .tooltip {
	display: block;
}

.tooltip-holder {
	width: 230px;
	padding: 12px;
	color: #fff;
	background: rgba(71, 62, 97, 0.8);
	border-radius: 8px;
	position: relative;

	&:after {
		position: absolute;
		left: 10px;
		top: 100%;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 10px 10px 0 10px;
		border-color: rgba(71, 62, 97, 0.8) transparent transparent transparent;
		content: '';
	}
}
</style>
